import {action, makeObservable, observable, runInAction} from "mobx";

import {AdminApi} from "../../../api/api";
import {TagSearchInput} from "../../../api/values/tag-search-input";
import {Stores} from "../../../stores";
import {Permission} from "../../../stores/authentication-store";
import {PageStoreConstructorOptions} from "../../../utils/page-store";
import {PageRouter} from "../../../utils/route-util";
import {TagAddStore} from "../../organisms/tag-add-button/tag-add-store";
import {TagDeleteStore} from "./tag-delete-store";

class TagItem {
    public label: string = "";

    public slug: string = "";

    public constructor(args?: Partial<TagItem>) {
        Object.assign(this, args);
    }
}

export class TagListPageStore {
    @observable public mediaId: string = "";
    @observable public tags: TagItem[] = [];

    public tagAddStore: TagAddStore;
    public tagDeleteStore: TagDeleteStore;
    private adminApi: AdminApi;
    private stores: Stores;
    private pageRouter: PageRouter;

    constructor(options: PageStoreConstructorOptions) {
        this.adminApi = options.adminApi;
        this.stores = options.stores;
        this.pageRouter = options.pageRouter;
        this.tagAddStore = new TagAddStore({adminApi: this.adminApi, mediaId: this.mediaId});
        this.tagDeleteStore = new TagDeleteStore({
            adminApi: this.adminApi,
            stores: this.stores,
            mediaId: this.mediaId,
        });

        makeObservable(this);
    }

    @observable
    public async initialize({query}: any) {
        this.stores.authenticationStore.checkAnyPermissionExists(Permission.EDIT_GENERAL_RESOURCES);
        const q = query || {};
        this.setMediaId(q.mediaId);
        await this.load();
    }

    @action.bound
    public async load() {
        try {
            this.tagAddStore.mediaId = this.mediaId;
            this.tagDeleteStore.mediaId = this.mediaId;
            const result = await this.adminApi.getTags(new TagSearchInput({mediaId: this.mediaId}));
            runInAction(() => {
                this.tags = result.tags.map((t) => new TagItem({label: t.label, slug: t.slug}));
            });
        } catch (e) {
            console.error(e);
        }
    }
    @action.bound
    public setMediaId(mediaId: string) {
        this.mediaId = mediaId;
    }
}
